import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import PopupForm from './PopupForm';
import { Link, useNavigate } from "react-router-dom";
import Schema from '../components/Schema';

const Products = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedProduct, ] = useState(null);


  const productList = [
    {
      id: 1,
      name: 'SolarCleano F1',
      description: 'Your all-in-one solar panel cleaning solution. The SolarCleano F1 is a remote-controlled solar panel cleaning robot with the highest cleaning capacity on the market. Suitable for wet and dry cleaning on any type of solar installations.',
      image: '/Images/products/Asset_9.png',
      price: 110.0,
      stock: true,
      category: 'robots',
      link: 'https://solarcleano.com/en/products/SC-F1.jpg',
      Description: 'Add your Description'
    },
    {
      id: 2,
      name: 'Jinko Solar',
      description: 'This is a great product.',
      image: '/Images/products/Jinko Solar.png',
      price: 110.0,
      stock: true,
      category: 'panels',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Add your Description'
    },
    {
      id: 3,
      name: 'Longi Solar',
      description: 'This is a great product.',
      image: '/Images/products/Longi Solar.png',
      price: 110.0,
      stock: true,
      category: 'panels',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Add your Description'
    },
    {
      id: 4,
      name: 'SolarCleano M1',
      description: 'This is a great product.',
      image: '/Images/products/M1-3.jpg',
      price: 110.0,
      stock: true,
      category: 'robots',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Add your Description'
    },
    {
      id: 11,
      name: 'JA Solar',
      description: 'This is a great product.',
      image: '/Images/products/JA Solar.jpg',
      price: 110.0,
      stock: true,
      category: 'panels',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Add your Description'
    },
    {
      id: 12,
      name: 'SolarCleano L1',
      description: 'This is a great product.',
      image: '/Images/products/SC-L1.jpg',
      price: 110.0,
      stock: true,
      category: 'robots',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Add your Description'
    },
    {
      id: 13,
      name: 'SolarCleano T1',
      description: 'This is a great product.',
      image: '/Images/products/SC-T1.jpg',
      price: 110.0,
      stock: true,
      category: 'robots',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Add your Description'
    },
    {
      id: 14,
      name: 'SolarCleano B1',
      description: 'This is a great product.',
      image: '/Images/products/SC-B!.jpg',
      price: 110.0,
      stock: true,
      category: 'robots',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Add your Description'
    },
    {
      id: 16,
      name: 'SUN2000-2/3/3.68/4/4.6/5/6KTL-L1',
      description: 'This is a great product.',
      image: '/Images/products/sun.png',
      price: 110.0,
      stock: true,
      category: 'inverters',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Single Phase inverter'
    },
    {
      id: 17,
      name: 'SUN2000-3/4/5/6/8/10KTL-M1',
      description: 'This is a great product.',
      image: '/Images/products/sunm1.jpeg',
      price: 110.0,
      stock: true,
      category: 'inverters',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Three Phase inverter'
    },
    {
      id: 18,
      name: 'SUN2000-12/15/17/20KTL-M2',
      description: 'This is a great product.',
      image: '/Images/products/sunm2.png',
      price: 110.0,
      stock: true,
      category: 'inverters',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Three Phase inverter'
    },
    {
      id: 19,
      name: 'Water Drainage Clamps (35mm)',
      description: 'This is a great product.',
      image: '/Images/products/Water_Drainage_Clamps__35mm_-removebg-preview.png',
      price: 110.0,
      stock: true,
      category: 'panels',
      link: 'https://www.chemitek.pt/products/lichen-removal-agent',
      Description: 'Three Phase inverter'
    },
  ];

  // const categories = ['all', 'cleaning chemical','cleaning kit', 'brushes', 'robots', 'panels', 'inverters', 'others'];
  
  // const categories = ['all','panels', 'inverters', 'robots', 'cleaning kit', 'brushes',  'others'];
  const categories = ['all','panels', 'inverters', 'robots'];

  const navigate = useNavigate();

const handleBuyNowClick = (product) => {
  navigate(`/buy/${product.id}`, { state: { product } });
};

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // const handleBuyNowClick = (product) => {
  //   setSelectedProduct(product);
  //   setIsPopupVisible(true);
  // };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  const handleSubmitForm = (formData) => {
    console.log('Form submitted:', formData);
    // Handle form submission logic (e.g., sending data to the server)
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      easing: 'ease-in-out', // animation easing
      once: true, // whether animation should happen only once - while scrolling down
    });
  }, []);


  useEffect(() => {
    // Add the fadeIn and zoomIn styles
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
      @keyframes zoomIn { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }
      .modal { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.75); animation: fadeIn 0.3s ease-in-out; }
      .modal img { max-width: 90%; max-height: 90%; object-fit: contain; animation: zoomIn 0.3s ease-in-out; }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const filteredProducts = productList.filter((product) => {
    const matchesCategory = selectedCategory === 'all' || product.category === selectedCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) || product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });  

  return (
    <div className="min-h-screen px-4 sm:px-6 py-10 bg-gray-100">
    <Schema />
  <h1
          className="text-6xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl 2xl:text-8xl font-bold text-black text-center mb-10"
        >
    Our Products
  </h1>

{/* Category Buttons + Chemitek Link */}
<div className="flex justify-center gap-4 flex-wrap mb-12">
  {categories.map((cat) => (
    <button
      key={cat}
      onClick={() => handleCategoryChange(cat)}
      className={`px-6 py-2 rounded-xl text-sm font-semibold transition-colors duration-300
        ${
          selectedCategory === cat
            ? 'bg-black text-white shadow-md'
            : 'bg-white text-gray-800 border border-gray-300 hover:bg-gray-100'
        }`}
      style={{ fontVariantNumeric: 'tabular-nums' }}
    >
      {cat}
    </button>
  ))}

  {/* Chemitek Products Button */}
  <Link
    to="/sola-cleaning-chemicals"
    className="px-6 py-2 rounded-xl text-sm font-semibold bg-white text-gray-800 border border-gray-300 hover:bg-gray-100 transition-colors duration-300"
  >
    Chemitek Products
  </Link>
</div>

{/* Search Input */}
<div className="flex justify-center mb-12">
  <input
    type="text"
    placeholder="⌕ Search products..."
    value={searchTerm}
    onChange={handleSearchChange}
    className="w-full sm:w-1/3 px-5 py-3 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition"
  />
</div>


  {/* Product Cards Grid */}
  <div className="w-full flex justify-center px-4 overflow-visible">
  <div className="max-w-7xl w-full grid grid-cols-1 md:grid-cols-2 gap-12">
    {filteredProducts.map((product) => (
      <div
        key={product.id}
        className="flex flex-col md:flex-row bg-white rounded-3xl overflow-hidden transition-transform duration-300 ease-in-out hover:scale-[1.02]"
      >
        {/* Image Section */}
        <div className="md:w-1/2 w-full bg-gray-50 flex justify-center items-center p-6">
          <img
            src={product.image}
            alt={product.name}
            className="w-full max-h-80 object-contain"
          />
        </div>

        {/* Content Section */}
        <div className="md:w-1/2 w-full p-6 flex flex-col justify-between">
          <div>
            <h3 className="text-3xl font-semibold text-black mb-3">{product.name}</h3>
            <p className="text-gray-600 text-base leading-relaxed mb-4">{product.description}</p>
            {/* <p className="text-lg font-medium text-gray-900 mb-1">Rs. {product.price.toFixed(2)}/=</p> */}
            <p className="text-sm text-gray-500">{product.stock ? 'In stock' : 'Out of stock'}</p>

            {product.link && (
              <a
                href={product.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block mt-3 text-sm text-blue-600 hover:underline"
              >
                About Product
              </a>
            )}
          </div>

          <div className="flex flex-row flex-wrap gap-3 mt-6">
            <button
              onClick={() => handleBuyNowClick(product)}
              className="px-4 py-1.5 rounded-md bg-black text-white text-sm font-medium hover:bg-gray-900 transition"
            >
              Buy Now
            </button>
            <button
              onClick={() => window.open(product.leaflet, '_blank')}
              className="px-4 py-1.5 rounded-md border border-black text-black text-sm hover:bg-gray-100 transition"
            >
              View Product →
            </button>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

  {/* Image Modal */}
  {selectedImage && (
    <div className="modal" onClick={closeModal}>
      <img src={selectedImage} alt="Full view" onClick={(e) => e.stopPropagation()} />
    </div>
  )}  
)

  {/* Popup Form for Buying */}
  <PopupForm
  isVisible={isPopupVisible}
  onClose={handleClosePopup}
  onSubmit={handleSubmitForm}
  product={selectedProduct}
/>

</div>
  );
};

export default Products;